import { ClassConstructor } from '@portal-core/util/types/class-constructor.type';
import { Subscription } from 'rxjs';

interface AutoUnsubscribeOptions {
  event?: string;
  excludes?: string[];
}

/**
 * Automatically calls unsubscribe on all Subscription properties on a component when the component is destroyed.
 *
 * @deprecated Prefer `takeUntilDestroyed()` from `@angular/core/rxjs-interop` to tie a subscription's
 * lifetime to the component, instead of storing `Subscription`s as fields for this decorator to sweep
 * on `ngOnDestroy`. Retained for the components still using the field-subscription pattern.
 */
export function AutoUnsubscribe({ excludes = [], event = 'ngOnDestroy' }: AutoUnsubscribeOptions = {}) {
  return function (constructor: ClassConstructor) {
    const original: (...args: unknown[]) => void = constructor.prototype[event];

    constructor.prototype[event] = function (...args: unknown[]) {
      for (const propName in this) {
        if (excludes.includes(propName)) {
          continue;
        }

        const property = this[propName];
        if (property instanceof Subscription) {
          property.unsubscribe();
        }
      }

      if (typeof original === 'function') {
        original.apply(this, args);
      }
    };
  };
}
